import { render, staticRenderFns } from "./CheckboxOption.vue?vue&type=template&id=25f0acc0"
import script from "./CheckboxOption.vue?vue&type=script&lang=js"
export * from "./CheckboxOption.vue?vue&type=script&lang=js"
import style0 from "./CheckboxOption.vue?vue&type=style&index=0&id=25f0acc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports